export const isServer: boolean = typeof window === 'undefined';